import updateAccountableBankingOnboarding from 'api/v2/transactions/updateAccountableBankingOnboarding';
import { useMutation } from 'react-query';

const useInitiateAccountableBankingOnboarding = () => {
  return useMutation(updateAccountableBankingOnboarding);
};

export default useInitiateAccountableBankingOnboarding;
